export { default } from "./Avatar-component";
